// // pages/SubjectTestsPage.jsx
// import React, { useEffect, useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
// import { db } from "../firebaseConfig";
// import ErrorMessage from "../components/common/ErrorMessage";

// const SubjectTestsPage = () => {
//   const { subjectId } = useParams();
//   const [subject, setSubject] = useState(null);
//   const [chapterTests, setChapterTests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchSubjectData();
//   }, [subjectId]);

//   // Function to fetch subject data and its tests
//   const fetchSubjectData = async () => {
//     try {
//       setLoading(true);
      
//       // Fetch the subject details
//       const subjectDoc = await getDoc(doc(db, "subjectTests", subjectId));
      
//       if (subjectDoc.exists()) {
//         setSubject({ id: subjectDoc.id, ...subjectDoc.data() });
        
//         // Fetch tests for this subject
//         const testsSnapshot = await getDocs(
//           query(collection(db, "tests"), where("subjectId", "==", subjectId))
//         );
        
//         const testsData = testsSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data()
//         }));
        
//         // Group tests by chapter
//         const groupedTests = {};
//         testsData.forEach(test => {
//           if (!groupedTests[test.chapterId]) {
//             groupedTests[test.chapterId] = [];
//           }
//           groupedTests[test.chapterId].push(test);
//         });
        
//         setChapterTests(groupedTests);
//       } else {
//         setError("Subject not found!");
//       }
      
//       setLoading(false);
//     } catch (err) {
//       console.error("Error fetching subject data:", err);
//       setError("Failed to load subject data. Please try again.");
//       setLoading(false);
//     }
//   };

//   // Default subject data if firestore data is not available yet
//   const defaultSubject = {
//     id: "maths",
//     title: "Mathematics",
//     chapters: [
//       { id: "chapter1", title: "Chapter 1: Numbers and Operations", tests: 5 },
//       { id: "chapter2", title: "Chapter 2: Algebra and Equations", tests: 4 },
//       { id: "chapter3", title: "Chapter 3: Geometry and Measurements", tests: 3 }
//     ]
//   };

//   // Default tests data
//   const getDefaultChapterTests = () => {
//     const defaultTests = {};
//     defaultSubject.chapters.forEach(chapter => {
//       defaultTests[chapter.id] = Array(chapter.tests).fill().map((_, index) => ({
//         id: `test-${chapter.id}-${index + 1}`,
//         title: `Test ${index + 1}`,
//         duration: "30 minutes",
//         questions: 20,
//         marks: 40,
//         difficulty: ["Easy", "Medium", "Hard"][Math.floor(Math.random() * 3)]
//       }));
//     });
//     return defaultTests;
//   };

//   // Show loading state
//   if (loading) {
//     return (
//       <div className="min-h-screen pt-20 flex justify-center items-center bg-gray-50">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
//         <p className="ml-3 text-blue-600 font-medium">Loading subject tests...</p>
//       </div>
//     );
//   }

//   // Show error state
//   if (error) {
//     return <ErrorMessage message={error} />;
//   }

//   // Use either fetched data or default data
//   const displaySubject = subject || defaultSubject;
//   const displayChapterTests = Object.keys(chapterTests).length > 0 ? chapterTests : getDefaultChapterTests();

//   return (
//     <div className="pt-20">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="max-w-3xl">
//             <motion.h1
//               className="text-3xl md:text-4xl font-bold mb-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               {displaySubject.title} Tests
//             </motion.h1>
//             <motion.p
//               className="text-lg text-blue-100 mb-8"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Comprehensive chapter-wise tests to strengthen your understanding of {displaySubject.title}
//             </motion.p>
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/test-series"
//                 className="inline-flex items-center text-blue-200 hover:text-white transition-colors"
//               >
//                 <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
//                 </svg>
//                 Back to Test Series
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Chapter Tests Section */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {displaySubject.chapters.map((chapter, index) => (
//             <motion.div
//               key={chapter.id}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: index * 0.1 }}
//               className="mb-12 last:mb-0"
//             >
//               <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
//                 <h2 className="text-2xl font-bold text-gray-900">{chapter.title}</h2>
//                 <span className="mt-2 md:mt-0 inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
//                   {chapter.tests} Tests
//                 </span>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {displayChapterTests[chapter.id] && displayChapterTests[chapter.id].map((test, testIndex) => (
//                   <div
//                     key={test.id}
//                     className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
//                   >
//                     <div className="p-6">
//                       <h3 className="text-lg font-bold text-gray-900 mb-2">{test.title}</h3>
//                       <div className="space-y-2 mb-6">
//                         <div className="flex items-center text-sm text-gray-600">
//                           <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                           </svg>
//                           <span>Duration: {test.duration}</span>
//                         </div>
//                         <div className="flex items-center text-sm text-gray-600">
//                           <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                           </svg>
//                           <span>Questions: {test.questions}</span>
//                         </div>
//                         <div className="flex items-center text-sm text-gray-600">
//                           <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//                           </svg>
//                           <span>Marks: {test.marks}</span>
//                         </div>
//                         <div className="flex items-center text-sm">
//                           <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                           </svg>
//                           <span className={`
//                             ${test.difficulty === "Easy" ? "text-green-600" : ""}
//                             ${test.difficulty === "Medium" ? "text-yellow-600" : ""}
//                             ${test.difficulty === "Hard" ? "text-red-600" : ""}
//                           `}>
//                             Difficulty: {test.difficulty}
//                           </span>
//                         </div>
//                       </div>
//                       <div className="flex space-x-2">
//                         <Link
//                           to={`/take-test/${test.id}`}
//                           className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
//                         >
//                           Take Test
//                         </Link>
//                         <Link
//                           to={`/test-details/${test.id}`}
//                           className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
//                         >
//                           View Details
//                         </Link>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-12 bg-blue-50">
//         <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <h2 className="text-2xl font-bold text-gray-900 mb-4">Ready to test your knowledge?</h2>
//           <p className="text-lg text-gray-700 mb-6">
//             Complete all chapter tests to ensure comprehensive understanding of {displaySubject.title}.
//           </p>
//           <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
//             <Link
//               to="/register"
//               className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-md"
//             >
//               Enroll Now
//             </Link>
//             <Link
//               to="/test-series"
//               className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
//             >
//               Explore Other Subjects
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default SubjectTestsPage;
// pages/SubjectTestsPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import ErrorMessage from "../components/common/ErrorMessage";

const SubjectTestsPage = () => {
  const { subjectId } = useParams();
  const [subject, setSubject] = useState(null);
  const [chapterTests, setChapterTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSubjectData();
  }, [subjectId]);

  // Function to fetch subject data and its tests
  const fetchSubjectData = async () => {
    try {
      setLoading(true);
      
      // Fetch the subject details
      const subjectDoc = await getDoc(doc(db, "subjectTests", subjectId));
      
      if (subjectDoc.exists()) {
        setSubject({ id: subjectDoc.id, ...subjectDoc.data() });
        
        // Fetch tests for this subject
        const testsSnapshot = await getDocs(
          query(collection(db, "tests"), where("subjectId", "==", subjectId))
        );
        
        const testsData = testsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Group tests by chapter
        const groupedTests = {};
        testsData.forEach(test => {
          if (!groupedTests[test.chapterId]) {
            groupedTests[test.chapterId] = [];
          }
          groupedTests[test.chapterId].push(test);
        });
        
        setChapterTests(groupedTests);
      } else {
        setError("Subject not found!");
      }
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching subject data:", err);
      setError("Failed to load subject data. Please try again.");
      setLoading(false);
    }
  };

  // Default subject data if firestore data is not available yet
  const defaultSubject = {
    id: "maths",
    title: "Mathematics",
    chapters: [
      { id: "chapter1", title: "Chapter 1: Numbers and Operations", tests: 5 },
      { id: "chapter2", title: "Chapter 2: Algebra and Equations", tests: 4 },
      { id: "chapter3", title: "Chapter 3: Geometry and Measurements", tests: 3 }
    ]
  };

  // Default tests data
  const getDefaultChapterTests = () => {
    const defaultTests = {};
    defaultSubject.chapters.forEach(chapter => {
      defaultTests[chapter.id] = Array(chapter.tests).fill().map((_, index) => ({
        id: `test-${chapter.id}-${index + 1}`,
        title: `Test ${index + 1}`,
        duration: "30 minutes",
        questions: 20,
        marks: 40,
        difficulty: ["Easy", "Medium", "Hard"][Math.floor(Math.random() * 3)]
      }));
    });
    return defaultTests;
  };

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen pt-20 flex justify-center items-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
        <p className="ml-3 text-blue-600 font-medium">Loading subject tests...</p>
      </div>
    );
  }

  // Show error state
  if (error) {
    return <ErrorMessage message={error} />;
  }

  // Use either fetched data or default data
  const displaySubject = subject || defaultSubject;
  const displayChapterTests = Object.keys(chapterTests).length > 0 ? chapterTests : getDefaultChapterTests();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <motion.h1
              className="text-3xl md:text-4xl font-bold mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {displaySubject.title} Tests
            </motion.h1>
            <motion.p
              className="text-lg text-blue-100 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Comprehensive chapter-wise tests to strengthen your understanding of {displaySubject.title}
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/test-series"
                className="inline-flex items-center text-blue-200 hover:text-white transition-colors"
              >
                <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Test Series
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Chapter Tests Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {displaySubject.chapters.map((chapter, index) => (
            <motion.div
              key={chapter.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="mb-12 last:mb-0"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">{chapter.title}</h2>
                  {chapter.description && (
                    <p className="text-gray-600 mt-1">{chapter.description}</p>
                  )}
                </div>
                <div className="mt-2 md:mt-0 flex items-center space-x-2">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    {chapter.tests || chapter.testCount} Tests
                  </span>
                  {chapter.status && (
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                      chapter.status === 'active' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {chapter.status === 'active' ? 'Available' : 'Coming Soon'}
                    </span>
                  )}
                </div>
              </div>

              {/* Show tests if available, otherwise show coming soon message */}
              {displayChapterTests[chapter.id] && displayChapterTests[chapter.id].length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {displayChapterTests[chapter.id].map((test, testIndex) => (
                    <div
                      key={test.id}
                      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
                    >
                      <div className="p-6">
                        <h3 className="text-lg font-bold text-gray-900 mb-2">{test.title}</h3>
                        <div className="space-y-2 mb-6">
                          <div className="flex items-center text-sm text-gray-600">
                            <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Duration: {test.duration}</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Questions: {test.totalQuestions || test.questions || 20}</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                            <span>Marks: {test.totalMarks || test.marks || 40}</span>
                          </div>
                          <div className="flex items-center text-sm">
                            <svg className="w-4 h-4 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                            <span className={`
                              ${test.difficulty === "Easy" ? "text-green-600" : ""}
                              ${test.difficulty === "Medium" ? "text-yellow-600" : ""}
                              ${test.difficulty === "Hard" ? "text-red-600" : ""}
                            `}>
                              Difficulty: {test.difficulty}
                            </span>
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          {test.status === 'active' || !test.status ? (
                            <>
                              <Link
                                to={`/take-test/${test.id}`}
                                className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                              >
                                Take Test
                              </Link>
                              <Link
                                to={`/test-details/${test.id}`}
                                className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
                              >
                                View Details
                              </Link>
                            </>
                          ) : (
                            <div className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-500 bg-gray-100 cursor-not-allowed">
                              Coming Soon
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : chapter.status === 'coming_soon' ? (
                <div className="bg-white rounded-lg shadow-md p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-yellow-100 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Tests Coming Soon</h3>
                  <p className="text-gray-600 mb-4">
                    We're preparing comprehensive tests for this chapter. Stay tuned for updates!
                  </p>
                  <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
                    <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9h6v6H9z" />
                    </svg>
                    In Development
                  </div>
                </div>
              ) : (
                <div className="bg-white rounded-lg shadow-md p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">No Tests Available</h3>
                  <p className="text-gray-600">
                    Tests for this chapter are not yet available. Please check back later.
                  </p>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 bg-blue-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Ready to test your knowledge?</h2>
          <p className="text-lg text-gray-700 mb-6">
            {displaySubject.status === 'active' 
              ? `Take available tests to strengthen your understanding of ${displaySubject.title}.`
              : `Complete all chapter tests to ensure comprehensive understanding of ${displaySubject.title}.`
            }
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link
              to="/register"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-md"
            >
              Enroll Now
            </Link>
            <Link
              to="/test-series"
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              Explore Other Subjects
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubjectTestsPage;